import { PiDownloadSimple, PiTrash } from "react-icons/pi";
import BackButton from "../../common/BackButton";
import Button from "../../common/Button";

const SelectedFileHeader = ({ file, isDeleteLoading, onDeleteClick, onBackClick }) => {
	const handleDownloadClick = () => {
		// TODO: Handle download
	};

	return (
		<div style={{ paddingTop: 20, display: "flex", alignItems: "center" }}>
			<BackButton onClick={onBackClick} />

			<div
				style={{
					width: "fit-content",
					marginLeft: "auto",
					display: "flex",
					alignItems: "center",
					gap: 8,
				}}
			>
				<Button type="icon" onClick={handleDownloadClick}>
					<PiDownloadSimple />
				</Button>
				<Button isLoading={isDeleteLoading} type="icon" onClick={onDeleteClick}>
					<PiTrash />
				</Button>
			</div>
		</div>
	);
};

export default SelectedFileHeader;
